import { SeoHead } from "@/components/SeoHead"
import { ReportExitHeader } from "./components/ReportExitHeader"

export default function ReportFailed({ seo, coach, mode, currentUser = null }) {
  const isPeerGroup = mode === "peer_group"
  const coachName = coach?.name || "Your coach"

  return (
    <>
      <SeoHead seo={{ ...seo, noIndex: true }} />
      <ReportExitHeader currentUser={currentUser} />
      <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6">
        <div className="max-w-lg w-full text-center space-y-6">
          <h1 className="font-display text-2xl">
            {isPeerGroup
              ? `${coachName} will follow up personally`
              : "Your coach will review personally"}
          </h1>
          <p className="text-zinc-600 leading-relaxed">
            {isPeerGroup
              ? `${coachName} will look over everything you shared and reach out to talk it through with you.`
              : `${coachName} will review your responses personally and be in touch within 24 hours to talk through what you shared.`}
          </p>
          <p className="text-zinc-500 text-sm">
            Thanks for taking the time to share. You'll hear from us shortly.
          </p>
        </div>
      </div>
    </>
  )
}
